// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:33:35

export default {
  "id": "strawberry-boardgames",
  "slug": "strawberry-boardgames",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/90279e90af1d4281943da6a44922d0af-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/90279e90af1d4281943da6a44922d0af/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Strawberry BoardGames",
      "description": "Visit the BerryWorks cafeteria and play checkers, memory, tic-tac-toe, connecting pairs, and complete jigsaw puzzles with your friends.",
      "instructions": "The game is controlled with the computer mouse or with a finger on mobile devices",
      "genres": [
        "Cards"
      ],
      "tags": [
        "kidgames"
      ]
    },
    "zh-CN": {
      "title": "草莓桌游",
      "description": "访问BerryWorks食堂，和朋友们一起玩跳棋、记忆游戏、井字棋、连接配对和完成拼图。",
      "instructions": "游戏可通过电脑鼠标或移动设备上的手指操作",
      "genres": [
        "卡牌"
      ],
      "tags": [
        "儿童游戏"
      ]
    },
    "zh-TW": {
      "title": "草莓桌面遊戲",
      "description": "參觀BerryWorks的餐廳，和你的朋友一起玩跳棋、記憶遊戲、井字遊戲、連接配對遊戲，並完成拼圖。",
      "instructions": "遊戲可使用電腦滑鼠或手機設備上的手指操控",
      "genres": [
        "卡片"
      ],
      "tags": [
        "兒童遊戲"
      ]
    },
    "zh-HK": {
      "title": "草莓桌遊",
      "description": "前往BerryWorks食堂，與朋友玩跳棋、記憶遊戲、井字遊戲、連接對子遊戲，並完成拼圖。",
      "instructions": "遊戲可透過電腦滑鼠或手機設備上的手指操控",
      "genres": [
        "牌"
      ],
      "tags": [
        "兒童遊戲"
      ]
    },
    "ja": {
      "title": "ストロベリーボードゲーム",
      "description": "ベリワークの給食処を訪れ、チェス、記憶ゲーム、ティック・タック・トゥー、連続パターン、そして友人たちとジグソーパズルを遊んでください。",
      "instructions": "ゲームはコンピュータのマウスまたはモバイルデバイス上での指で操作されます",
      "genres": [
        "カード"
      ],
      "tags": [
        "キッドゲームズ"
      ]
    },
    "ko": {
      "title": "딸기 보드게임",
      "description": "베리워크 식당을 방문하여 칭크, 기억, 타일, 연결된 쌍, 그리고 친구들과 함께 조각 퍼즐을 해결하세요.",
      "instructions": "게임은 컴퓨터 마우스나 모바일 기기에서 손가락으로 제어됩니다.",
      "genres": [
        "카드"
      ],
      "tags": [
        "키드게임즈"
      ]
    },
    "fr": {
      "title": "Battes de Fraises (Jeux de Plateau)",
      "description": "Visitez la cantine BerryWorks et jouez aux dames, à la mémoire, au tic-tac-toe, aux paires connectées et assemblez des puzzles de puzzle avec vos amis.",
      "instructions": "Le jeu est contrôlé avec la souris du ordinateur ou avec un doigt sur les appareils mobiles.",
      "genres": [
        "Cartes"
      ],
      "tags": [
        "jeux pour enfants"
      ]
    }
  }
};
